"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.to-string");
require("core-js/modules/es6.regexp.replace");
var _projectType = require("@/api/project/projectType");
var _resourceDatabaseManagement = require("@/api/resourceDatabaseManagement/resourceDatabaseManagement");
var _backMen = require("@/api/backmen/backMen");
var _fileUpload = _interopRequireDefault(require("@/components/fileUpload.vue"));
var _index = _interopRequireDefault(require("@/components/fileImg/index.vue"));
var _school = require("@/api/school/school");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    FileUpload: _fileUpload.default,
    fileUpload: _index.default
  },
  data: function data() {
    return {
      schoolListData: [],
      dataSourceList: [{
        name: '国家平台',
        id: 1
      }, {
        name: '省管理员',
        id: 2
      }, {
        name: '校管理员',
        id: 3
      }],
      accept: ".png,.jpg,.pdf",
      prolist: [],
      //专业大类
      courseList: [],
      // 课程来源
      typeList: [],
      // 类型
      List: [],
      //项目级别
      industryList: [],
      //产业分类
      industryCategoryList: [],
      //行业门类
      courseTypeList: [],
      // 资源库类别
      appliTypeList: [],
      // 应用类型
      mediaTypeList: [],
      // 媒体类型
      form: {
        checkStatus: "",
        code: "",
        createDate: "",
        dataSource: null,
        emceeCompanyname: "",
        firstMajorId: "",
        fkSiteSecretId: 0,
        freeLoginLink: "",
        id: this.$route.query.id || '',
        industry: "",
        industryDetail: "",
        industryDetailName: "",
        link: "",
        majorId: "",
        majorLevel: "",
        name: "",
        newSource: 0,
        onState: 0,
        origin: "",
        participationCompanyname: "",
        presidedTeacher: "",
        previewPic: "",
        province: this.$store.getters.provinceId,
        rowCreateTime: "",
        rowUpdateTime: "",
        schoolId: "",
        secondMajorId: "",
        sort: 0,
        thumbsUp: 0,
        updateDate: "",
        userCount: 0

        // courseName: "", //课程名称
        // courseImage: "", //课程封面
        // hostTeacher: "", //主持教师
        // studentNumber: "", //学习人数
        // schoolId: "", //学校
        // majorCatId: "", //专业大类
        // freeLoginLink: "", //免登录链接
        // courseLink: "", //课程链接
        // // schoolType: "", //所属平台
        // courseSource: "", // 课程来源
        // repositoryType: "", //资源库类型
        // resourceLibraryType: "", //资源库类别
        // projectLevel: "", //项目级别
        // applicationType: "", // 应用类型
        // mediaType: "", //媒体类型
        // sort: "", //排序
        // isPut: 1,
        // createBy: "", // 创建人id
        // createTime: "",
        // remark: "",
        // industryCategory: "", // 行业门类
        // industryClassification: "", // 产业分类
        // isDelete: 0,
        // provinceId: this.$store.getters.provinceId,
        // updateTime: ""
      },
      rules: {
        name: [{
          required: true,
          message: "请输入项目名称。",
          trigger: "blur"
        }],
        // presidedTeacher: [
        //   { required: true, message: "请选择主持教师。", trigger: "change" }
        // ],
        link: [{
          required: true,
          message: "此项不能为空",
          trigger: "blur"
        }, {
          type: 'url',
          message: '请输入以http://或https://开头的网址',
          trigger: ['blur', 'change']
        }]
        // courseLink:[
        //   { required: true, message: "此项不能为空", trigger: "blur" },
        //   {type: 'url', message: '请输入以http://或https://开头的网址',trigger: ['blur', 'change']},
        // ],
        // courseSource:[{ required: true, message: "此项不能为空", trigger: "blur" }],
        // studentNumber:[{ required: true, message: "此项不能为空", trigger: "blur" }],
      }
    };
  },
  methods: {
    isnumber: function isnumber(val) {
      val = val.replace(/[^0-9]/gi, "");
      // 此处还可以限制位数以及大小
      return val;
    },
    // 获取课程来源
    getCourseList: function getCourseList() {
      var _this = this;
      (0, _resourceDatabaseManagement.courseList)({
        name: "",
        pageNum: "",
        pageSize: "",
        provinceId: this.$store.getters.provinceId
      }).then(function (res) {
        console.log("//", res);
        _this.courseList = res.data;
      });
    },
    // 课程封面
    successUpLoad: function successUpLoad(e) {
      // console.log('e',e)
      // this.form.uploadFile = e;
      this.form.previewPic = e.ossOriUrl;
    },
    // 提交
    submit: function submit(v) {
      var _this2 = this;
      this.form.industryDetail = this.form.industryDetail.toString();
      this.$refs[v].validate(function (valid) {
        if (valid) {
          if (_this2.$route.query.id) {
            (0, _resourceDatabaseManagement.resourceUpload)(_this2.form).then(function (res) {
              if (res.code === 2000) {
                _this2.$message.success("操作成功。");
                _this2.$router.push("/resourceManagement/resourceDatabaseManagement");
              }
            });
          } else {
            (0, _resourceDatabaseManagement.resourceAdd)(_this2.form).then(function (res) {
              if (res.code === 2000) {
                _this2.$message.success("操作成功。");
                _this2.$router.push("/resourceManagement/resourceDatabaseManagement");
              }
            });
          }
        }
      });
    },
    // 返回
    isBack: function isBack() {
      this.$router.push("/resourceManagement/resourceDatabaseManagement");
    }
  },
  created: function created() {
    var _this3 = this;
    if (this.$route.query.id) {
      (0, _resourceDatabaseManagement.getPeMajorInfoById)({
        id: this.$route.query.id
      }).then(function (res) {
        _this3.form = res.data;
        _this3.form.schoolId = _this3.form.emceeCompanyname;
      });
    }
    // 获取专业大类
    (0, _projectType.categoriesList)({
      pageNum: 1,
      pageSize: 999999,
      provinceId: this.$store.getters.provinceId,
      type: ""
    }).then(function (res) {
      _this3.prolist = res.data.list;
    });
    (0, _school.schoolList)({
      bureauId: '',
      queryValue: '',
      type: 0,
      pageSize: 999999,
      pageNum: 1
    }).then(function (res) {
      var data = res.data;
      _this3.schoolListData = data.list;
    });
    // 课程来源
    this.getCourseList();
    // 类型
    this.typeList = this.$store.getters.wResourceType;
    // 项目级别
    this.List = this.$store.getters.wProjectLevel;
    // 资源库类别
    this.courseTypeList = this.$store.getters.wProfessionalResourceLibraryType;
    // 应用类型
    this.appliTypeList = this.$store.getters.wApplicationType;
    // 媒体类型
    this.mediaTypeList = this.$store.getters.wMediaType;
    // 行业门类
    this.industryCategoryList = this.$store.getters.wIndustryCategory;
    // 产业分类
    // this.form.industryClassification = this.$store.getters.wIndustryType.name
    this.industryList = this.$store.getters.wIndustryType;
  }
};